module.exports = __webpack_public_path__ + "static/media/hitashi-bansal.ed3080ed.png";